// extracted by mini-css-extract-plugin
export default {"emailIcon":"EmailLink_emailIcon__JrYcW"};